module.exports = __webpack_public_path__ + "static/planetar-cbfea293694d9660988affb7c33c1a7a.jpeg";